const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["./popup-age-verification.script-global-D93zdh0T.js","./index-DKb_bFk4.js","./index-DHaxRrJP.js","./popup-countdown-promo.script-global-t1hCeb_k.js","./popup-promo.script-global-udiYJEEU.js","./popup-sign-up.script-global-BUfkI-zR.js","./benefit.script-global-wi8OgKCS.js","./customElements-DWxXfmld.js","./index-D8cE2RrJ.js","./index-BaEy46h7.js","./index-BroJWfm5.js","./collection-list-type-1.script-global-DeIvGBQD.js","./xo-collection-list.script-global-CUZyLbSh.js","./each-DSCw-kmU.js","./image-with-text-type-3.script-global-Bcgwe2Do.js","./index-D71docwu.js","./navigator.script-global-BNFgSWQr.js","./product-grid-type-1.script-global-_swlhIVV.js","./product-grid-type-6.script-global-BDTlKKv-.js","./service.script-global-CSCR8FEC.js","./cart-shipping.script-global-Dizg4VqB.js","./cart-show-tab.script-global-BvxKoaby.js","./currency-select-Bix9Ct7e.js","./language-select-CN2_rf_l.js","./menu-horizontal.script-global-BvstmYEa.js","./menu-scroll-DIgmOSpw.js","./predictive-search-CC0d4OLm.js","./product-card.script-global-BSZP0aFW.js","./share-4nR-DC9j.js","./select-category.script-global-CFU3ZieD.js","./recommendations-nav.script-global-B2-yVlVS.js"])))=>i.map(i=>d[i]);
const scriptRel = "modulepreload";
const assetsURL = function(dep, importerUrl) {
  return new URL(dep, importerUrl).href;
};
const seen = {};
const __vitePreload = function preload(baseModule, deps, importerUrl) {
  let promise = Promise.resolve();
  if (deps && deps.length > 0) {
    let allSettled2 = function(promises) {
      return Promise.all(
        promises.map(
          (p) => Promise.resolve(p).then(
            (value) => ({ status: "fulfilled", value }),
            (reason) => ({ status: "rejected", reason })
          )
        )
      );
    };
    const links = document.getElementsByTagName("link");
    const cspNonceMeta = document.querySelector(
      "meta[property=csp-nonce]"
    );
    const cspNonce = (cspNonceMeta == null ? void 0 : cspNonceMeta.nonce) || (cspNonceMeta == null ? void 0 : cspNonceMeta.getAttribute("nonce"));
    promise = allSettled2(
      deps.map((dep) => {
        dep = assetsURL(dep, importerUrl);
        if (dep in seen) return;
        seen[dep] = true;
        const isCss = dep.endsWith(".css");
        const cssSelector = isCss ? '[rel="stylesheet"]' : "";
        const isBaseRelative = !!importerUrl;
        if (isBaseRelative) {
          for (let i = links.length - 1; i >= 0; i--) {
            const link2 = links[i];
            if (link2.href === dep && (!isCss || link2.rel === "stylesheet")) {
              return;
            }
          }
        } else if (document.querySelector(`link[href="${dep}"]${cssSelector}`)) {
          return;
        }
        const link = document.createElement("link");
        link.rel = isCss ? "stylesheet" : scriptRel;
        if (!isCss) {
          link.as = "script";
        }
        link.crossOrigin = "";
        link.href = dep;
        if (cspNonce) {
          link.setAttribute("nonce", cspNonce);
        }
        document.head.appendChild(link);
        if (isCss) {
          return new Promise((res, rej) => {
            link.addEventListener("load", res);
            link.addEventListener(
              "error",
              () => rej(new Error(`Unable to preload CSS for ${dep}`))
            );
          });
        }
      })
    );
  }
  function handlePreloadError(err) {
    const e = new Event("vite:preloadError", {
      cancelable: true
    });
    e.payload = err;
    window.dispatchEvent(e);
    if (!e.defaultPrevented) {
      throw err;
    }
  }
  return promise.then((res) => {
    for (const item of res || []) {
      if (item.status !== "rejected") continue;
      handlePreloadError(item.reason);
    }
    return baseModule().catch(handlePreloadError);
  });
};
const groupGlobalModules = /* @__PURE__ */ Object.assign({ "../groups/popups/popup-age-verification/popup-age-verification.script-global.ts": () => __vitePreload(() => import("./popup-age-verification.script-global-D93zdh0T.js"), true ? __vite__mapDeps([0,1,2]) : void 0, import.meta.url), "../groups/popups/popup-countdown-promo/popup-countdown-promo.script-global.ts": () => __vitePreload(() => import("./popup-countdown-promo.script-global-t1hCeb_k.js"), true ? __vite__mapDeps([3,1,2]) : void 0, import.meta.url), "../groups/popups/popup-promo/popup-promo.script-global.ts": () => __vitePreload(() => import("./popup-promo.script-global-udiYJEEU.js"), true ? __vite__mapDeps([4,1,2]) : void 0, import.meta.url), "../groups/popups/popup-sign-up/popup-sign-up.script-global.ts": () => __vitePreload(() => import("./popup-sign-up.script-global-BUfkI-zR.js"), true ? __vite__mapDeps([5,1,2]) : void 0, import.meta.url) });
Object.values(groupGlobalModules).forEach((module) => module());
const sectionsGlobalModules = /* @__PURE__ */ Object.assign({ "../sections/benefit/benefit.script-global.ts": () => __vitePreload(() => import("./benefit.script-global-wi8OgKCS.js"), true ? __vite__mapDeps([6,1,7,8,9,2,10]) : void 0, import.meta.url), "../sections/collection-list-type-1/collection-list-type-1.script-global.ts": () => __vitePreload(() => import("./collection-list-type-1.script-global-DeIvGBQD.js"), true ? __vite__mapDeps([11,1,7,8,9,2,10]) : void 0, import.meta.url), "../sections/collection-list-type-1/xo-collection-list.script-global.ts": () => __vitePreload(() => import("./xo-collection-list.script-global-CUZyLbSh.js"), true ? __vite__mapDeps([12,1,13,7,8,9,2,10]) : void 0, import.meta.url), "../sections/image-with-text-type-3/image-with-text-type-3.script-global.ts": () => __vitePreload(() => import("./image-with-text-type-3.script-global-Bcgwe2Do.js"), true ? __vite__mapDeps([14,15,10,1,13,2]) : void 0, import.meta.url), "../sections/navigator/navigator.script-global.ts": () => __vitePreload(() => import("./navigator.script-global-BNFgSWQr.js"), true ? __vite__mapDeps([16,1,13,7,8,9,2,10]) : void 0, import.meta.url), "../sections/product-grid-type-1/product-grid-type-1.script-global.ts": () => __vitePreload(() => import("./product-grid-type-1.script-global-_swlhIVV.js"), true ? __vite__mapDeps([17,1,7,8,9,2,10]) : void 0, import.meta.url), "../sections/product-grid-type-6/product-grid-type-6.script-global.ts": () => __vitePreload(() => import("./product-grid-type-6.script-global-BDTlKKv-.js"), true ? __vite__mapDeps([18,1,7,8,9,2,10]) : void 0, import.meta.url), "../sections/service/service.script-global.ts": () => __vitePreload(() => import("./service.script-global-CSCR8FEC.js"), true ? __vite__mapDeps([19,1,7,8,9,2,10]) : void 0, import.meta.url) });
Object.values(sectionsGlobalModules).forEach((module) => module());
const snippetModules = /* @__PURE__ */ Object.assign({ "../snippets/cart-free-shipping/cart-shipping.script-global.ts": () => __vitePreload(() => import("./cart-shipping.script-global-Dizg4VqB.js"), true ? __vite__mapDeps([20,1,7,8,9,2,10]) : void 0, import.meta.url), "../snippets/cart-mini/cart-show-tab.script-global.ts": () => __vitePreload(() => import("./cart-show-tab.script-global-BvxKoaby.js"), true ? __vite__mapDeps([21,1,7,8,9,2,10]) : void 0, import.meta.url), "../snippets/currency-select/currency-select.ts": () => __vitePreload(() => import("./currency-select-Bix9Ct7e.js"), true ? __vite__mapDeps([22,15,10,1,13,2]) : void 0, import.meta.url), "../snippets/language-select/language-select.ts": () => __vitePreload(() => import("./language-select-CN2_rf_l.js"), true ? __vite__mapDeps([23,15,10,1,13,2]) : void 0, import.meta.url), "../snippets/menu-horizontal/menu-horizontal.script-global.ts": () => __vitePreload(() => import("./menu-horizontal.script-global-BvstmYEa.js"), true ? __vite__mapDeps([24,1,7,8,9,2,10]) : void 0, import.meta.url), "../snippets/menu-scroll/menu-scroll.ts": () => __vitePreload(() => import("./menu-scroll-DIgmOSpw.js"), true ? __vite__mapDeps([25,1,13]) : void 0, import.meta.url), "../snippets/predictive-search/predictive-search.ts": () => __vitePreload(() => import("./predictive-search-CC0d4OLm.js"), true ? __vite__mapDeps([26,1,9]) : void 0, import.meta.url), "../snippets/predictive-search/types.ts": () => __vitePreload(() => Promise.resolve().then(() => types), true ? void 0 : void 0, import.meta.url), "../snippets/product-card/product-card.script-global.ts": () => __vitePreload(() => import("./product-card.script-global-BSZP0aFW.js"), true ? __vite__mapDeps([27,1,7,8,9,2,10]) : void 0, import.meta.url), "../snippets/share/share.ts": () => __vitePreload(() => import("./share-4nR-DC9j.js"), true ? __vite__mapDeps([28,15,10,1,13,2,8,9]) : void 0, import.meta.url), "../snippets/transform-pill/transform-pill.script-global.ts": () => __vitePreload(() => import("./transform-pill.script-global-C7_acMa9.js"), true ? [] : void 0, import.meta.url) });
Object.values(snippetModules).forEach((module) => module());
const pagesGlobalModules = /* @__PURE__ */ Object.assign({ "../pages/product/snippets/product-info-content-left-type-2/select-category.script-global.ts": () => __vitePreload(() => import("./select-category.script-global-CFU3ZieD.js"), true ? __vite__mapDeps([29,1,7,8,9,2,10]) : void 0, import.meta.url), "../pages/product/snippets/product-recommendations/recommendations-nav.script-global.ts": () => __vitePreload(() => import("./recommendations-nav.script-global-B2-yVlVS.js"), true ? __vite__mapDeps([30,1,7,8,9,2,10]) : void 0, import.meta.url) });
Object.values(pagesGlobalModules).forEach((module) => module());
const SELECTORS = {
  PRICE: ".xo-price__item",
  COMPARE_AT_PRICE: ".xo-price__item.xo-price__item--del",
  BUTTON_ADD: ".shopify-payment-button__add",
  BUTTON_ADD_TEXT: ".xo-btn__text"
};
function updatePrice(targetProductId, price) {
  const priceEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.PRICE}`);
  priceEls.forEach((priceEl) => {
    priceEl.innerHTML = price;
  });
}
function updateCompareAtPrice(targetProductId, price) {
  const compareAtPriceEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.COMPARE_AT_PRICE}`);
  compareAtPriceEls.forEach((compareAtPriceEl) => {
    compareAtPriceEl.innerHTML = price;
  });
}
function soldOutMessage(targetProductId, message) {
  const buttonEls = document.querySelectorAll(`xo-product[xo-product-id="${targetProductId}"] ${SELECTORS.BUTTON_ADD}`);
  buttonEls.forEach((buttonEl) => {
    const btnTextEl = buttonEl.querySelector(SELECTORS.BUTTON_ADD_TEXT);
    if (btnTextEl) {
      btnTextEl.innerHTML = message;
    }
    buttonEl.style.pointerEvents = "none";
  });
}
window.Xotiny = window.Xotiny || {};
window.Xotiny.updatePrice = updatePrice;
window.Xotiny.updateCompareAtPrice = updateCompareAtPrice;
window.Xotiny.soldOutMessage = soldOutMessage;
console.log("%c Pastarina theme by Xotiny ", "background:#243b90;color: #fff", "Learn more at https:/xotiny.com/");
const types = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));


// Product Modifiers System
class ProductModifiers {
  constructor() {
    this.container = document.querySelector('.product-modifiers');
    if (!this.container) return;
    
    this.form = document.querySelector('form[action*="/cart/add"]');
    this.modifierCheckboxes = document.querySelectorAll('.modifier-checkbox');
    this.basePriceEl = document.querySelector('.base-price');
    this.modifiersPriceEl = document.querySelector('.modifiers-price');
    this.totalPriceEl = document.querySelector('.total-price');
    this.modifiersPriceRow = document.querySelector('.modifiers-price-row');
    this.selectedModifiersInput = document.querySelector('.selected-modifiers-input');
    
    this.basePrice = parseInt(this.container.dataset.basePrice);
    
    this.init();
  }
  
  init() {
    if (!this.form || this.modifierCheckboxes.length === 0) return;
    
    this.modifierCheckboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.updatePrice());
    });
    
    this.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
    
    this.updatePrice();
  }
  
  updatePrice() {
    let modifiersTotal = 0;
    const selectedModifiers = [];
    
    this.modifierCheckboxes.forEach(checkbox => {
      if (checkbox.checked) {
        const price = parseInt(checkbox.dataset.price) || 0;
        modifiersTotal += price;
        selectedModifiers.push(checkbox.dataset.modifierName);
      }
    });
    
    const total = this.basePrice + modifiersTotal;
    
    if (modifiersTotal > 0) {
      this.modifiersPriceRow.style.display = 'flex';
      this.modifiersPriceEl.textContent = this.formatMoney(modifiersTotal);
    } else {
      this.modifiersPriceRow.style.display = 'none';
    }
    
    this.totalPriceEl.innerHTML = '<strong>' + this.formatMoney(total) + '</strong>';
    
    if (this.selectedModifiersInput) {
      this.selectedModifiersInput.value = selectedModifiers.join(', ');
    }
    
    const mainPriceEl = document.querySelector('.price-item--regular');
    if (mainPriceEl) {
      mainPriceEl.textContent = this.formatMoney(total);
    }
  }
  
  formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }
  
  handleFormSubmit(e) {
    return true;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ProductModifiers();
});

if (typeof Shopify !== 'undefined' && Shopify.theme) {
  document.addEventListener('shopify:section:load', () => {
    new ProductModifiers();
  });
}

